
<div>
    <c-card-iterator
        :items          = "items"
        :label          = "$t('todo.guard.failed.title2')"
        :loading        = "loading"
        :title-prefix   = "true"
        :pagination-on  = "true"
        :item-height    = "76"
        :min-height     = "topHeight"
        :filter         = "match"
        :filter-height  = "72"
        :height         = "null"
    >
        <template v-slot:card="{ item }">
            <p-inc-guard-protocol-failed-card
                :protocol = "item"
                @assign   = "onAssign"
                @delete   = "onDelete"
            />
        </template>
    </c-card-iterator>
</div>
